var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top"}},[_c('div',{staticClass:"priceWrapper",staticStyle:{"margin-bottom":"1rem"}},[(
        _vm.loading &&
          _vm.size < 20971520 &&
          _vm.item.valuation !== null &&
          _vm.item.valuation !== '' &&
          _vm.item.valuation !== undefined
      )?_c('div',{staticStyle:{"text-align":"center","font-size":".8rem","margin-top":"2rem"}},[_c('i',{staticClass:"el-icon-loading"})]):_vm._e(),_vm._v(" "),(_vm.show)?_c('div',{class:{ hidden: _vm.loading, none: !_vm.loading && _vm.size >= 20971520 }},[_c('iframe',{staticClass:"ifme",attrs:{"id":"test","src":'https://docs.google.com/gview?embedded=true&url=' + _vm.item.valuation}})]):_vm._e(),_vm._v(" "),(
        !_vm.loading &&
          _vm.size >= 20971520 &&
          _vm.item.valuation !== null &&
          _vm.item.valuation !== '' &&
          _vm.item.valuation !== undefined
      )?_c('div',{staticClass:"fail"},[_c('a',{staticClass:"btn",attrs:{"href":_vm.item.valuation,"target":"_blank"}},[_vm._v("Download PDF")])]):_vm._e(),_vm._v(" "),(_vm.item.valuation == null && !_vm.loading)?_c('div',{staticClass:"fail"},[_c('p',[_vm._v("Not Uploaded Yet.")])]):_vm._e()]),_vm._v(" "),_c('reverse',{attrs:{"showCall":false,"showReserve":_vm.$route.query.publicFlag &&
        _vm.$route.query.publicFlag !== undefined &&
        _vm.$route.query.publicFlag !== null},on:{"accept":_vm.reserve}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799a6540","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/valuation/valuation.vue
// module id = null
// module chunks = 